module.exports = __webpack_public_path__ + "img/Trinidad and Tobago.91447582.gif";